export default "__VITE_ASSET__Cvx$XOwB__"